import React from "react";

const formatCreditDelta = (value) => {
  const numericValue = Number(value);

  if (Number.isNaN(numericValue)) {
    return value;
  }

  return `${numericValue > 0 ? "+" : ""}${numericValue}`;
};

const getCreditDeltaClassName = (value) => {
  const numericValue = Number(value);

  if (numericValue > 0) {
    return "transactionHistory-delta is-positive";
  }

  if (numericValue < 0) {
    return "transactionHistory-delta is-negative";
  }

  return "transactionHistory-delta";
};

const getInitials = (name = "") =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("");

const CreditHistoryTable = ({ title = "Credit History", rows = [] }) => {
  return (
    <div className="transactionHistory-card">
      <div className="transactionHistory-sectionLabel">{title}</div>

      <div className="transactionHistory-tableWrap">
        <div className="transactionHistory-table transactionHistory-tableHead">
          <div>Date</div>
          <div>Team Member</div>
          <div>Action</div>
          <div>Credits</div>
          <div>Remaining</div>
        </div>

        {rows.map((row) => (
          <div className="transactionHistory-table transactionHistory-row" key={row.id}>
            <div className="transactionHistory-cellLabel">Date</div>
            <div>{row.date}</div>

            <div className="transactionHistory-cellLabel">Team Member</div>
            <div className="transactionHistory-memberCell">
              <div className="transactionHistory-memberAvatar">
                {getInitials(row.member.name)}
              </div>
              <div>
                <div className="transactionHistory-memberName">{row.member.name}</div>
                <div className="transactionHistory-memberEmail">{row.member.email}</div>
              </div>
            </div>

            <div className="transactionHistory-cellLabel">Action</div>
            <div className="transactionHistory-actionText">{row.action}</div>

            <div className="transactionHistory-cellLabel">Credits</div>
            <div>
              <span className={getCreditDeltaClassName(row.credits)}>
                {formatCreditDelta(row.credits)}
              </span>
            </div>

            <div className="transactionHistory-cellLabel">Remaining</div>
            <div className="transactionHistory-remainingValue">{row.remaining}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreditHistoryTable;
